import React from 'react'
import * as styles from './index.module.css'

const Spacer = ({
  spacer_ref: {
    backgroundColor,
    includeHorizontalRule,
    useOusterGradient,
    horizontalRuleColor,
    horizontalRuleHeight,
    height,
    mobileHeight,
    displayOnMobile,
  },
}) => {
  const isMobile = typeof window !== `undefined` && window.innerWidth <= 450
  height = height ? height : 50
  height = isMobile && mobileHeight ? mobileHeight : height
  horizontalRuleHeight = horizontalRuleHeight ? horizontalRuleHeight : 5
  const horizontalRuleStyle = {
    height: `${horizontalRuleHeight}px`,
    width: '100%',
    background:
      useOusterGradient === 'Blue to orange'
        ? 'linear-gradient(to right,#150461,#c724b0,#d50032,#ff3d45,#fc9e21)'
        : useOusterGradient === 'Orange to blue'
        ? 'linear-gradient(to left,#150461,#c724b0,#d50032,#ff3d45,#fc9e21)'
        : horizontalRuleColor,
  }

  if (isMobile && displayOnMobile === false) {
    return null
  }

  return (
    <div
      className={styles.container}
      style={{ height: `${height}px`, backgroundColor: backgroundColor }}
    >
      {includeHorizontalRule !== 'No' && (
        <div
          className={includeHorizontalRule === 'Body width' ? 'wrapper' : ''}
          style={horizontalRuleStyle}
        />
      )}
    </div>
  )
}

export default Spacer
